"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Avatar_1 = tslib_1.__importDefault(require("@mui/material/Avatar"));
const List_1 = tslib_1.__importDefault(require("@mui/material/List"));
const ListItemButton_1 = tslib_1.__importDefault(require("@mui/material/ListItemButton"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const stringToAvatarLetters_1 = require("../_InternalUtils/stringToAvatarLetters");
const colors_1 = require("../colors");
const ArgusMenuContactUs_1 = tslib_1.__importDefault(require("./ArgusMenuContactUs"));
const ArgusMenuLink_1 = tslib_1.__importDefault(require("./ArgusMenuLink"));
const StyledListItem_1 = tslib_1.__importDefault(require("./StyledListItem"));
const useBreakpoints_1 = require("./useBreakpoints");
const ArgusMenuUserMenu = ({ items, name, imageSrc, logger, ListItemProps, ListItemButtonProps, ListItemTextProps, }) => {
    const ref = (0, react_1.useRef)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const { isDesktop } = (0, useBreakpoints_1.useBreakpoints)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledListItem_1.default, { ref: ref, ...ListItemProps },
            react_1.default.createElement(ListItemButton_1.default, { onClick: () => setAnchorEl(ref.current), ...{ sx: { alignItems: "center", p: 0 }, ...ListItemButtonProps } },
                isDesktop && (react_1.default.createElement(ListItemText_1.default, { ...{
                        primary: name,
                        primaryTypographyProps: { variant: "body2" },
                        sx: { color: "primary.contrastText", mr: 1, whiteSpace: "nowrap" },
                        ...ListItemTextProps,
                    } })),
                react_1.default.createElement(Avatar_1.default, { ...{
                        alt: "profile picture",
                        src: imageSrc,
                    } }, (0, stringToAvatarLetters_1.stringToAvatarLetters)(name, { maxChars: 2 })))),
        react_1.default.createElement(Popover_1.default, { ...{
                elevation: 0,
                TransitionProps: { timeout: 0 },
                onClose: () => setAnchorEl(null),
                open: Boolean(anchorEl),
                anchorEl,
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
                PaperProps: { sx: { borderRadius: 0 } },
            } },
            react_1.default.createElement(List_1.default, { component: "div", sx: {
                    p: 0,
                    bgcolor: colors_1.black["800"],
                    borderRadius: 0,
                } }, items?.map((item) => {
                if (item.kind === "contactUs") {
                    return (react_1.default.createElement(ArgusMenuContactUs_1.default, { ...{
                            ...item,
                            logger,
                            key: "contactUs",
                            ArgusMenuButtonProps: {
                                disableShrinking: true,
                                ListItemTextProps: { primaryTypographyProps: { variant: "body2" } },
                                ListItemButtonProps: {
                                    style: { alignItems: "end" },
                                },
                            },
                        } }));
                }
                else {
                    return (react_1.default.createElement(ArgusMenuLink_1.default, { key: item?.label, disableShrinking: true, ...{
                            logger,
                            ListItemTextProps: { primaryTypographyProps: { variant: "body2" } },
                            ListItemButtonProps: {
                                style: { alignItems: "end" },
                            },
                            ...item,
                        } }));
                }
            })))));
};
exports.default = ArgusMenuUserMenu;
